import type {
  ErrorTracker,
  ErrorTrackerConfig,
  ErrorTrackerUser,
  ErrorTrackerBreadcrumb,
} from './types';

/**
 * No-op error tracker for environments where tracking is disabled.
 * Logs to console in development for debugging visibility.
 */
export class NoopTracker implements ErrorTracker {
  init(_config: ErrorTrackerConfig): void {}

  captureException(error: unknown, context?: Record<string, unknown>): void {
    if (import.meta.env.DEV) {
      console.debug('[ErrorTracker:noop] Would capture:', error, context);
    }
  }

  setUser(_user: ErrorTrackerUser | null): void {}
  setTags(_tags: Record<string, string | boolean>): void {}
  addBreadcrumb(_breadcrumb: ErrorTrackerBreadcrumb): void {}
  isInitialized(): boolean { return false; }
}
